<template>
    <div class="container-top">
        <div class="top-box">
            <div class="top-left">
                <img class="band-icon" @click="navigateTo('home')" src="https://cos.astrolinkwatch.com/bdwatch_official/containerTop/01band.png">
            </div>
            <div class="top-right">
                <div
                    class="top-left-text"
                    :class="{ 'text-active': activeText === 'watches' }"
                    @click="navigateTo('watches')"
                    @mouseenter="showHoverBox = true"
                >
                    WATCHES
                </div>
                <div
                    class="top-left-text"
                    :class="{ 'text-active': activeText.indexOf('support') !== -1 }"
                    @click="navigateTo('support')"
                >
                    SUPPORT
                </div>
                <div
                    class="top-left-text"
                    :class="{ 'text-active': activeText === 'brand' }"
                    @click="navigateTo('brand')"
                >
                    BRAND
                </div>
                <div
                    class="top-left-text"
                    :class="{ 'text-active': activeText === 'partners' }"
                    @click="navigateTo('partners')"
                >
                    PARTNERS
                </div>
<!--                <div class="lang-box">-->
<!--                    <img class="right-icon" src="https://cos.astrolinkwatch.com/bdwatch_official/containerTop/02lang.png">-->
<!--                    <div class="top-right-text">EN</div>-->
<!--                </div>-->
<!--                <div class="login-box">-->
<!--                    <img class="right-icon" src="https://cos.astrolinkwatch.com/bdwatch_official/containerTop/03login.png">-->
<!--                    <div class="top-right-text">LOGIN</div>-->
<!--                </div>-->
<!--                <div class="store-box">-->
<!--                    <img class="store-icon" src="https://cos.astrolinkwatch.com/bdwatch_official/containerTop/04store.png">-->
<!--                    <div class="top-right-text">STORE</div>-->
<!--                </div>-->
            </div>
        </div>
        <div class="hover-box" @mouseleave="showHoverBox = false" v-if="showHoverBox">
            <div class="band-box">
                <div class="band-item" @click="navigateTo('astrolinks')">
                    <img class="band-img" src="https://cos.astrolinkwatch.com/bdwatch_official/watches/02w1.png">
                    <div class="band-title">ASTROLINK S</div>
                </div>
                <div class="band-item" @click="navigateTo('astrolinkg')">
                    <img class="band-img" src="https://cos.astrolinkwatch.com/bdwatch_official/watches/02w8.png">
                    <div class="band-title">ASTROLINK G</div>
                </div>
                <div class="band-item" @click="navigateTo('astrolinku')">
                    <img class="band-img" src="https://cos.astrolinkwatch.com/bdwatch_official/watches/02w9.png">
                    <div class="band-title">ASTROLINK U</div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'index',
    data() {
        return {
            showSelect: false,
            activeText: 'home', // 默认选中 HOME
            showHoverBox: false
        }
    },
    watch: {
        $route() {
            this.activeText = this.$route.name;
        }
    },
    methods: {
        navigateTo(page) {
            this.activeText = page; // 更新选中的文本
            switch (page) {
                case 'home':
                    this.$router.push({ name: 'home' });
                    break;
                case 'watches':
                    this.$router.push({ name: 'watches' });
                    break;
                case 'astrolinks':
                    this.$router.push({ name: 'astrolinks' });
                    break;
                case 'astrolinkg':
                    this.$router.push({ name: 'astrolinkg' });
                    break;
                case 'astrolinku':
                    this.$router.push({ name: 'astrolinku' });
                    break;
                case 'support':
                    this.$router.push({ name: 'support' });
                    break;
                case 'brand':
                    this.$router.push({ name: 'brand' });
                    break;
                case 'partners':
                    this.$router.push({ name: 'partners' });
                    break;
                default:
                    console.log('Page not found');
            }
        }
    }
}
</script>


<style scoped>
.top-box {
    width: 1920px;
    height: 80px;
    background: #000000;
    min-width: 960px;
    font-family: PH-Regular;
    display: flex;
    justify-content: space-between;
}

.band-icon {
    width: 120px;
    margin-left: 120px;
    margin-right: 97px;
    cursor: pointer;
}

.top-left {
    display: flex;
    align-items: center;
    height: 100%;
}

.top-left-text {
    font-size: 16px;
    color: #777777;
    margin: 0 32px;
    cursor: pointer;
    height: 80px;
    line-height: 80px;
}

.top-left-text:hover {
    color: #ffffff;
}

.text-active {
    color: #ffffff;
}

.top-right {
    display: flex;
    align-items: center;
    justify-items: center;
    height: 100%;
    margin-right: 120px;
}

.right-icon {
    width: 12px;
    height: 12px;
    margin-left: 24px;
}

.top-right-text {
    font-size: 12px;
    color: #777777;
    display: inline-block;
    padding: 0 24px 0 10px;
    line-height: 12px;
    cursor: pointer;
}

.lang-box {
    border-right: 1px solid #444444;
    height: 14px;
    display: flex;
}

.login-box {
    display: flex;
}

.store-box {
    display: flex;
    border: 1px solid #777777;
    padding: 9px 6px 9px 30px;
    margin-left: 40px;
}

.store-icon {
    width: 12px;
}

.hover-box {
    width: 1920px;
    background: rgba(17,17,17,0.8);
    margin-top: -10px;
    z-index: 111;
    position: absolute;
    top: 80px;
}

.band-box {
    width: 1920px;
    height: 249px;
    display: flex;
    justify-content: center;
}

.band-item {
    width: 95px;
    margin: 30px 144px;
    cursor: pointer;
}

.band-img {
    width: 95px;
}

.band-title {
    font-size: 14px;
    color: #ffffff;
    font-family: PH-Regular;
    margin-top: 14px;
}

.more-box {
    font-size: 14px;
    color: #FFFFFF;
    font-family: PH-Regular;
    text-align: center;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/layout/ContainerTop/index.vue